/* global WebView, ViewController,scriptLoader */
var initLogin = require("../../util/initLogin") ;

var LoginController = ViewController.create({
    directory : "views/login",
    name: "login",
    container: "main",
    noRouting: true
}) ;

LoginController.prototype.prepareDataOnEnter = function(urlData, callback){
    this.api.public.getGlobalSettings(function(err, settings){
        if(err){ return callback(err) ;}

        var data = {
            lang: WebView.i18n.getLang(),
            settings: settings,
            hasAutoDb: localStorage.getItem("last_login_url")
        } ;
        urlData = window.app.getRouteData("") ;
        if(urlData && urlData.error){
            data.error = urlData.error ;
            if(data.error === "UNKNOWN_EMAIL"){
                data.error = this.view.tr("login.unknownEmail") ;
            }else if(data.error === "ALREADY_DISABLED"){
                data.error = this.view.tr("login.alreadyDisabled") ;
            }
        }
        if(urlData && urlData.token){
            //window.app.updateRouteData("", null) ;
            var authSession = localStorage.getItem("auth-session") ;
            this.api.auth.userToken("office365", urlData.token, authSession, function(err, user){
                if(err){
                    if((""+err).indexOf("HOUR_NOT_ALLOWED") !== -1 || (err === "Unauthorized" && this.data && this.data.error === this.view.tr("login.hourNotAllowed"))){
                        data.error = this.view.tr("login.hourNotAllowed") ;
                    }else{
                        data.error = this.view.tr("login.cantLogin") ;
                    }
                    return callback(null, data) ;
                }
                var indexData = window.location.hash.indexOf("#$") ;
                if(indexData !== -1){
                    var indexNextData = window.location.hash.indexOf("#", indexData+2) ;
                    if(indexNextData !== -1){
                        window.location.hash = window.location.hash.substring(indexNextData) ;
                    }else{
                        window.location.hash = "" ;
                    }
                }
                //login OK
        
                // initLogin(user, function(err){
                //     if(err){ return callback(err) ; }
                    //this.view.reload() ; 
            
                    //this.resumeNavigation("/") ;
                    // setTimeout(function(){
                        window.location.reload() ;
                    // }, 100) ;
                // }.bind(this)) ;
        
            }.bind(this)) ;
        }else{
            callback(null, data);
        }
    }.bind(this)) ;
};

LoginController.prototype.onLang = function(){
    this.view.updateData(); 
    WebView.i18n.setLang(this.data.lang) ;
} ;

LoginController.prototype.onChooseDb = function(){
    localStorage.removeItem("last_login_url") ;
    document.location.search = "?dbName="+WebView.uuid() ;
} ;

LoginController.prototype.focusLogin = function(){
    this.view.focusLogin() ;
};

LoginController.prototype.onConnect = function(){
    this.view.updateData(); 
    this.data.error = "" ;
    var errors = [] ;
    if(!this.data.connectLogin){
        errors.push(this.view.tr("login.pleaseInputLogin")) ;
    }
    if(!this.data.connectPassword){
        errors.push(this.view.tr("login.pleaseInputPassword")) ;
    }
    if(errors.length>0){
        this.data.error = errors.join("<br/>") ;
        return this.view.reload() ;
    }
    
    this._doConnect(this.data.connectLogin, this.data.connectPassword) ;
} ;

LoginController.prototype.onConnectByOffice365 = function(){
    this.view.longTask(function(done){
        var authSession = WebView.uuid() ;
        localStorage.setItem("auth-session", authSession) ;
        this.api.office365.getAuthUrl("", window.location.href, authSession, function(err, authUrl){
            if(err){ return done(err) ;}
            window.location.href = authUrl ;
            done() ;
        }) ;
    }.bind(this)) ;
} ;

LoginController.prototype._doConnect = function(connectLogin, connectPassword){
    this.view.longTask(function(done){
        this.api.auth.user(connectLogin, connectPassword, function(err, user){
            if(err){
                if((""+err).indexOf("HOUR_NOT_ALLOWED") !== -1){
                    this.data.error = this.view.tr("login.hourNotAllowed") ;
                }else{
                    this.data.error = this.view.tr("login.cantLogin") ;
                }
                this.view.reload() ;
                return done() ;
            }

            //login OK
            done() ;
            var endLogin = function(){
                this.view.longTask(function(done){
                    initLogin(user, function(err){
                        if(err){ return done(err) ; }

                        window.location.reload() ;
                        // this.view.reload() ; 
                
                        // this.resumeNavigation("/") ;
                        return done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this) ;

            if(user.iz_change_pass){
                this.view.longTask(function(done){
                    var viewChange = new WebView("views/main", "changePassword") ;
                    viewChange.openInPopup({
                        title: WebView.tr("main.changePassword"),
                        closeWithEsc: false,
                        closeable: false,
                    }, function(){
                        done() ;
                    }.bind(this))  ;
                    viewChange.on("validate",function(){
                        var data = viewChange.getData() ;
                        this.view.longTask(function(done){
                            this.api.auth.changeUserPassword(data.passwordOld, data.passwordNew, function(err, success){
                                if(err){ return done(err);}
                                if(!success){
                                    return done(WebView.tr("main.wrongPassword")) ;
                                }
                                viewChange.close() ;
                                done() ;
                                WebView.info(WebView.tr("main.changePasswordSuccess"), function(){
                                    endLogin() ;
                                }.bind(this)) ;
                            }.bind(this)) ;
                        }.bind(this)) ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }else{
                endLogin() ;
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

module.exports = new LoginController() ;